import * as CRM from './CRM';

export const Agents = {
  CRM,
};
